export const expenseRequestStatusEnum = {
  0: 'UNSPECIFIED',
  1: 'INITIATED',
  2: 'APPROVED',
  3: 'PENDING_CLARIFICATION',
  4: 'REJECTED',
  5: 'EXPIRED',
  UNSPECIFIED: 0,
  INITIATED: 1,
  APPROVED: 2,
  PENDING_CLARIFICATION: 3,
  REJECTED: 4,
  EXPIRED: 5,
};

export const expenseRequestActionErrorCode = {
  '0': 'UNSPECIFIED',
  '1': 'DEFAULT_FAILURE',
  '2': 'INVALID_REQUEST_VERSION',
  '3': 'RESPONSE_ALREADY_CAPTURED',
  '4': 'MISSING_REJECTION_REASON',
  '5': 'REQUEST_EXPIRED',
  UNSPECIFIED: '0',
  DEFAULT_FAILURE: '1',
  INVALID_REQUEST_VERSION: '2',
  RESPONSE_ALREADY_CAPTURED: '3',
  MISSING_REJECTION_REASON: '4',
  REQUEST_EXPIRED: '5',
};
